import React from 'react';
import './Header.css';
import logo from '../../assets/logo.svg';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  language?: string;
}

const Header: React.FC<HeaderProps> = ({ language = 'cpp' }) => {
  const { user } = useAuth();
  
  // 根据语言动态显示标题
  const getEnvironmentTitle = () => {
    switch (language.toLowerCase()) {
      case 'python':
        return 'Python在线编程环境';
      case 'cpp':
      case 'c++':
        return 'C++在线编程环境';
      case 'java':
        return 'Java在线编程环境';
      case 'javascript':
      case 'js':
        return 'JavaScript在线编程环境';
      default:
        return `${language}在线编程环境`;
    }
  };

  // 获取用户显示名称
  const getUserDisplayName = () => {
    if (!user) return '未登录';
    
    // 优先使用name字段，其次是username
    return user.name || user.username || '未知用户';
  };

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
        <h1>{getEnvironmentTitle()}</h1>
      </div>
      <div className="user-info">
        <img src={user?.avatar || logo} alt="User" className="user-avatar" />
        <span>{getUserDisplayName()}</span>
      </div>
    </header>
  );
};

export default Header;
